import { fetchAuthSession } from "aws-amplify/auth";
import { InternalAxiosRequestConfig } from "axios";

const axiosJwtInterceptor = async (config: InternalAxiosRequestConfig) => {
  try {
    const session = await fetchAuthSession({
      forceRefresh: !!config.params?.refreshToken,
    });
    const token = session.tokens?.idToken;

    if (token) {
      sessionStorage.setItem("idToken", token?.toString() ?? "");
      config!.headers!.Authorization = `Bearer ${token}`;
    } else {
      config!.headers!.Authorization = "";
    }
  } catch (error) {}

  return config;
};

export default axiosJwtInterceptor;
